// extracted by mini-css-extract-plugin
export default {"submissionError":"submissionError_submissionError__5mbti","entering":"submissionError_entering__PlgaE"};